import { call, put, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { appleUserLoginFailure, appleUserLoginSuccess } from '../../actions/authActions/appleUserLoginActions';
import { setAccessToken } from '../../../publicStore/actions/utilsActions/utilsActions';

function* appleUserLogin({ payload }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.appleUserLogin,
            payload: payload,
            isAuth: false,
        });
        console.log('====================================');
        console.log('APPLE_USER_LOGIN_SUCCESS status :', response.data.status);
        console.log('APPLE_USER_LOGIN_SUCCESS data :', response.data.response);
        console.log('APPLE_USER_LOGIN_SUCCESS message :', response.data.message);
        console.log('====================================');
        yield put(
            appleUserLoginSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message,
            })
        );
        yield put(setAccessToken(response?.data?.response?.accessToken));
    } catch (error) {
        console.log('====================================');
        console.log('APPLE_USER_LOGIN_FAILURE status :', error?.response?.status);
        console.log('APPLE_USER_LOGIN_FAILURE data:', error?.response?.data);
        console.log('APPLE_USER_LOGIN_FAILURE error :', error);
        console.log('====================================');
        yield put(
            appleUserLoginFailure({
                status: error?.response?.data?.status,
                response: {},
                message: error?.response?.data?.message,
            })
        );
    }
}

function* appleUserLoginSaga() {
    yield takeLatest(actionTypes.APPLE_USER_LOGIN_REQUEST, appleUserLogin);
}

export default appleUserLoginSaga;
